/**
 * Where a page's social card lives.
 *
 * Its own module, with no imports, because both the router (which runs in the
 * shell bundle and must stay small) and the build-time card generator need
 * it. Pulling this out of `structured-data.ts` keeps every content module out
 * of the first-paint chunk.
 *
 * `/` keeps `/og.png`: it is the shell's default, the one a client-side
 * navigation leaves in place when nothing better is known, and the one
 * `index.html` names.
 */
export function ogImagePath(path: string): string {
  if (path === '/') return '/og.png'
  return `/og/${path.replace(/^\//, '').replace(/\//g, '-')}.png`
}
